import React from 'react'
import './browse.css'
import SiteLayout from '../../component/layout/Layout'
import { Select, Row, Col, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import cardImgTop from '../../assets/img/banner_scroll.png'
const Browse = () => {

    const { Option } = Select;

    return(
        <SiteLayout>
            <div className="browse_header">
                <h1>Browse</h1>
                <ul>
                    <li className="active_link">Category</li>
                    <li>Tournament</li>
                </ul>
            </div>
            <div className="browse_body">

                <div className="browse_top_bar">
        
                    <div className="search_by">
                        <p>Filter by</p>
                        <Input.Group compact>
                            <div className="search_preffix">
                                <SearchOutlined />
                            </div>
                            <Select defaultValue="Search Tags">
                                <Option value="Tag2-1">Tag2-1</Option>
                                <Option value="Tag2-2">Tag2-2</Option>
                            </Select>
                        </Input.Group>
                    </div>

                    <div className="favourite">
                        <p>Sort by</p>
                        <Select defaultValue="Recommended For You">
                            <Option value="Tag2-1">Tag2-1</Option>
                            <Option value="Tag2-2">Tag2-2</Option>
                        </Select>
                    </div>

                </div>
            
                <div className="browse_card_holder">
                    <Row gutter={[ 16,24 ]}>

                        <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                    </div>
                                    <div className="card_body">
                                        <h3>Fifa 20</h3>
                                        <div className="card_game_title">
                                            <ul>
                                                <li>7 Games</li>
                                                <li>20 Playing</li>
                                            </ul>
                                        </div>
                                        <div className="browse_game_type">
                                            <div className="game_type_container">
                                                <p>Sports / Racing</p>
                                            </div>
                                            <div className="game_type_container">
                                                <p>PS4</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        
                        <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                    </div>
                                    <div className="card_body">
                                        <h3>Fifa 20</h3>
                                        <div className="card_game_title">
                                            <ul>
                                                <li>7 Games</li>
                                                <li>20 Playing</li>
                                            </ul>
                                        </div>
                                        <div className="browse_game_type">
                                            <div className="game_type_container">
                                                <p>Sports / Racing</p>
                                            </div>
                                            <div className="game_type_container">
                                                <p>PS4</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                    </div>
                                    <div className="card_body">
                                        <h3>Fifa 20</h3>
                                        <div className="card_game_title">
                                            <ul>
                                                <li>7 Games</li>
                                                <li>20 Playing</li>
                                            </ul>
                                        </div>
                                        <div className="browse_game_type">
                                            <div className="game_type_container">
                                                <p>Sports / Racing</p>
                                            </div>
                                            <div className="game_type_container">
                                                <p>PS4</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                    </div>
                                    <div className="card_body">
                                        <h3>Fifa 20</h3>
                                        <div className="card_game_title">
                                            <ul>
                                                <li>7 Games</li>
                                                <li>20 Playing</li>
                                            </ul>
                                        </div>
                                        <div className="browse_game_type">
                                            <div className="game_type_container">
                                                <p>Sports / Racing</p>
                                            </div>
                                            <div className="game_type_container">
                                                <p>PS4</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                    </div>
                                    <div className="card_body">
                                        <h3>Fifa 20</h3>
                                        <div className="card_game_title">
                                            <ul>
                                                <li>7 Games</li>
                                                <li>20 Playing</li>
                                            </ul>
                                        </div>
                                        <div className="browse_game_type">
                                            <div className="game_type_container">
                                                <p>Sports / Racing</p>
                                            </div>
                                            <div className="game_type_container">
                                                <p>PS4</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                    </div>
                                    <div className="card_body">
                                        <h3>Fifa 20</h3>
                                        <div className="card_game_title">
                                            <ul>
                                                <li>7 Games</li>
                                                <li>20 Playing</li>
                                            </ul>
                                        </div>
                                        <div className="browse_game_type">
                                            <div className="game_type_container">
                                                <p>Sports / Racing</p>
                                            </div>
                                            <div className="game_type_container">
                                                <p>PS4</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                    </Row>
                </div>

            </div>
        </SiteLayout>
    );
}

export default Browse;